import type { InventoryTransfer } from "../models/InventoryTransfer";
import { CreateCrudService } from "./CrudServiceFactory";
export function InventoryTransferService(warehouseCode?: string) {
  return CreateCrudService<InventoryTransfer>({
    Route: "inventory-transfer",
    PaginationInPath: true,
    WarehouseCode: warehouseCode,
    WarehouseFields: ["WareHouse", "ToWareHouse"],
    EntityName: "InventoryTransfer",
    DeleteAction: "DeleteInventoryTransfer",
    PartialFields: ["Code"],
    LoadingMessage: "Loading inventory transfers...",
    SavingMessage: "Saving inventory transfer...",
  });
}
